<template>
  <div class="pdf-generator">
    <button @click="generatePdf" class="generate-btn">生成PDF</button>
    
    <!-- 要转换为PDF的内容 -->
    <div id="pdf-content" class="pdf-content">
      <!-- 文字内容 -->
      <div class="pdf-section">
        <h1>销售报表</h1>
        <p>这是一份包含销售数据统计的报表，生成于 {{ currentDate }}</p>
        <p>本报表包含月度销售趋势图表和详细的产品销售数据表格，供管理层参考决策。</p>
      </div>
      
      <!-- ECharts图表 -->
      <div class="pdf-section">
        <h2>月度销售趋势</h2>
        <div id="sales-chart" ref="chart" class="chart-container"></div>
      </div>
      
      <!-- 表格 -->
      <div class="pdf-section">
        <h2>产品销售数据</h2>
        <table class="data-table">
          <thead>
            <tr>
              <th>产品名称</th>
              <th>销量</th>
              <th>销售额</th>
              <th>同比增长</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in tableData" :key="index">
              <td>{{ item.product }}</td>
              <td>{{ item.salesVolume }}</td>
              <td>{{ item.salesAmount }}</td>
              <td :class="item.growth >= 0 ? 'positive' : 'negative'">
                {{ item.growth >= 0 ? '+' : '' }}{{ item.growth }}%
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      
      <!-- 页脚 -->
      <div class="footer">
        <p>报表生成日期：{{ currentDate }} | 联系信息：support@example.com</p>
      </div>
    </div>
  </div>
</template>

<script>
// import * as echarts from 'echarts'
import html2pdf from 'html2pdf.js'

export default {
  name: 'PdfGenerator',
  data() {
    return {
      currentDate: '',
      tableData: [
        { product: '产品A', salesVolume: 1200, salesAmount: '¥240,000', growth: 12.5 },
        { product: '产品B', salesVolume: 850, salesAmount: '¥170,000', growth: 8.2 },
        { product: '产品C', salesVolume: 620, salesAmount: '¥124,000', growth: -3.1 },
        { product: '产品D', salesVolume: 1500, salesAmount: '¥300,000', growth: 15.8 },
        { product: '产品E', salesVolume: 980, salesAmount: '¥196,000', growth: 5.3 }
      ],
      chart: null
    }
  },
  mounted() {
    // 初始化日期
    this.currentDate = new Date().toLocaleDateString()
    
    // 初始化图表
    this.initChart()
  },
  methods: {
    // 初始化ECharts图表
    initChart() {
      this.chart = echarts.init(this.$refs.chart)
      
      // 图表配置
      const option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: ['1月', '2月', '3月', '4月', '5月', '6月']
        },
        yAxis: {
          type: 'value',
          name: '销售额(元)'
        },
        series: [
          {
            name: '销售额',
            type: 'bar',
            data: [320000, 380000, 420000, 360000, 480000, 520000],
            itemStyle: {
              color: '#337ab7'
            }
          }
        ]
      }
      
      this.chart.setOption(option)
      
      // 监听窗口大小变化，重绘图表
      window.addEventListener('resize', this.handleResize)
    },
    
    // 处理窗口大小变化
    handleResize() {
      if (this.chart) {
        this.chart.resize()
      }
    },
    
    // 生成PDF
    generatePdf() {
      // 获取要转换为PDF的元素
      const element = document.getElementById('pdf-content')
      
      // 配置选项
      const opt = {
        margin: 10,
        filename: '销售报表_' + new Date().toLocaleDateString().replace(/\//g, '-') + '.pdf',
        image: { type: 'jpeg', quality: 0.98 },
        html2canvas: { 
          scale: 2, // 提高分辨率
          useCORS: true,
          logging: false
        },
        jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' }
      }
      
      // 生成PDF
      html2pdf().from(element).set(opt).save()
    }
  },
  beforeDestroy() {
    // 移除事件监听
    window.removeEventListener('resize', this.handleResize)
    
    // 销毁图表实例，释放资源
    if (this.chart) {
      this.chart.dispose()
    }
  }
}
</script>

<style scoped>
.generate-btn {
  margin: 20px 0;
  padding: 10px 20px;
  background-color: #337ab7;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 16px;
}

.generate-btn:hover {
  background-color: #286090;
}

.pdf-content {
  width: 210mm; /* A4宽度 */
  margin: 0 auto;
  padding: 20mm;
  background-color: white;
  box-shadow: 0 0 10px rgba(0,0,0,0.1);
}

.pdf-section {
  margin-bottom: 20px;
}

h1, h2 {
  color: #333;
  margin-bottom: 10px;
}

p {
  line-height: 1.6;
  color: #666;
}

.chart-container {
  width: 100%;
  height: 400px;
  margin: 10px 0;
}

.data-table {
  width: 100%;
  border-collapse: collapse;
  margin: 10px 0;
}

.data-table th, .data-table td {
  border: 1px solid #ddd;
  padding: 8px 12px;
  text-align: left;
}

.data-table th {
  background-color: #f5f5f5;
  font-weight: bold;
}

.data-table tr:nth-child(even) {
  background-color: #f9f9f9;
}

.positive {
  color: #3c763d;
}

.negative {
  color: #a94442;
}

.footer {
  margin-top: 40px;
  padding-top: 10px;
  border-top: 1px solid #ddd;
  text-align: center;
  font-size: 14px;
  color: #999;
}
</style>
